import React from "react";
import "./NotLoginContainer.scss";
import { useContent } from "contexts/contentContext/contentContext.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import Button from "components/Elements/Button/Button.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import Login from "components/Structure/Login/Login.js";

const NotLoginContainer = ({ TitleKey, TextKey }) => {
  const { getTextByKey, getHtmlByKey } = useContent();
  const { setModal } = useModal();

  const handleOpenLogin = () => {
    setModal({
      modal: Login,
      modalSize: "full-modal",
    });
  };

  return (
    <div className="empty-container">
      <div className="not-login-container">
        <div className="not-login-img">
          <Icon iconClass="no-forms-img" name="no-forms" xxxl />
        </div>
        <div className="not-login-content">
          <h1>{getTextByKey(TitleKey)}</h1>
          <p>{getHtmlByKey(TextKey)}</p>
          <Button className="new-button" onClick={handleOpenLogin}>
            {getTextByKey("login")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotLoginContainer;
